const FormItemLayoutConf = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

const FieldTypes = {
    STRING: 'STRING_TYPE',
    NUMBER: 'NUMBER_TYPE',
    SELECT: 'SELECT',
    AUTOCOMPLETE:'AUTOCOMPLETE',
    DATE: 'DATE',
    DATE_RANGE: 'DATE_RANGE',
    TAG_AUTOCOMPLETE: 'TAG_AUTOCOMPLETE',
    TAG_AUTOCOMPLETE_RESTAURANT: 'TAG_AUTOCOMPLETE_RESTAURANT',
    SELECT_CUSTOM: 'SELECT_CUSTOM_TYPE',
};

export {
    FieldTypes,
    FormItemLayoutConf,
};